import React from "react";
import { Link } from "react-router-dom";
import "./Generic.css";

const Info = () => {
  return (
    <div>
      <blockquote>
        {/* Education Section */}
        <h1>Research and Education</h1>
        <h2>Kanzi's Voice</h2>
        <div>
          <Link to="/BonoboHopeKeyboard">
            <img
              className="featured-image"
              src="KeyboardP1_6.png"
              alt="Yerkish keyboard"
            />
          </Link>
        </div>
        <p>
          The <Link to="/BonoboHopeKeyboard">Bonobo Hope Keyboard</Link> has
          been carefully restored, one lexigram at a time. Now the keyboard is
          "live" and will pronounce words as they are selected. Talk like Kanzi!
        </p>

        {/* Research Section */}

        <h2>Research Foundation</h2>
        <p>
          Selected Publications of{" "}
          <Link to="/SueBiblio">E. Sue Savage-Rumbaugh</Link>
        </p>
      </blockquote>
    </div>
  );
};

export default Info;
